export default __webpack_public_path__ + "static/tone-jonez-f54d24874854e3bf4585c89aede64ec0.png";